import {
	Component,
	OnChanges,
	Input,
	Output,
	ChangeDetectorRef,
	ViewChildren,
	QueryList,
	EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';
import {
	CommunicationAddressDto,
	CountryLookupDto,
} from 'app/services';
import { CommAddrDisplayEditComponent } from '../comm-addr-display-edit/comm-addr-display-edit.component';

@Component({
	selector: 'pp-comm-addr-editor',
	templateUrl: './comm-addr-editor.component.html',
	styleUrls: ['./comm-addr-editor.component.scss']
})
export class CommAddrEditorComponent implements OnChanges  {
	commAddressesWithValues: CommunicationAddressDto[];
	canAddMore: boolean = true;
	addableTypes: string[];

	@Input() commAddresses: CommunicationAddressDto[];
	@Input() countries: CountryLookupDto[];
	@Input() readOnly: boolean;
	@Output() updated = new EventEmitter<boolean>();

	@ViewChildren(CommAddrDisplayEditComponent) editorQuery: QueryList<CommAddrDisplayEditComponent>;

	constructor(
		private cd: ChangeDetectorRef,
	) {}

	ngOnChanges(changes) {
		if (changes.commAddresses) {
			this.filterCommAddresses();
		}
	}

	commAddressUpdated(address) {
		this.filterCommAddresses();
		this.updated.emit(true);
	}

	addAddress(typeName: string) {
		const addressType = this.commAddresses.find(a => a.typeName === typeName);
		addressType.areaCode = '';
		addressType.text = '';
		this.commAddressesWithValues.push(addressType);

		this.cd.detectChanges();

		const comp = this.editorQuery.last;
		comp.add();
	}

	private filterCommAddresses(): void {
		this.commAddressesWithValues = (this.commAddresses || []).filter(a => {
			return a.text;
		});

		this.canAddMore = this.commAddressesWithValues.length < (this.commAddresses || []).length;
		const emptyTypes = _.difference(this.commAddresses, this.commAddressesWithValues);
		this.addableTypes = emptyTypes.map(t => t.typeName);
	}
}
